/*
 * <kremi-buy-now> — UGC video kartındaki "Hızlı satın al".
 *
 * DAVRANIŞ: varyantı sepete ekler, sonra ödemeye gider. Sepeti TEMİZLEMEZ.
 *
 * Favoriler ekranındaki aynı isimli buton sepeti temizliyor ("sadece bu favoriyi
 * al", karar 09-05) — burada BİLİNÇLİ olarak farklı davranıyoruz: ana sayfa
 * gezinme yüzeyi, ziyaretçinin sepetinde zaten ürün olabilir. Onu sessizce
 * silmek yıkıcı olurdu ve "3 Al 2 Öde" gibi sepete bağlı kampanyaları da
 * düşürürdü. Shopify'ın kendi "Hemen satın al" düğmesi de sepeti korur.
 *
 * SÜRÜKLEME ÇAKIŞMASI BURADA ÇÖZÜLMÜYOR: kart `swiper-no-swiping` sınıfı taşıyor,
 * Swiper'ın kendi mekanizması o alanda sürüklemeyi hiç başlatmıyor (bkz.
 * kremi-ugc-card.liquid). Swiper 11 `pointerdown` dinler — `mousedown` durdurmak
 * ONU ETKİLEMEZ; CardAddForm'daki mousedown çözümü temanın kendi
 * `scroll-carousel`'i içindir, buraya birebir taşınmaz.
 *
 * Bu dosya yüklenmezse buton hiçbir şey yapmaz; "Sepete ekle" ve videonun ürün
 * sayfası bağlantısı çalışmaya devam eder.
 */
class KremiBuyNow extends HTMLElement {
  connectedCallback() {
    this._root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    this._onClick = (event) => {
      const button = event.target.closest && event.target.closest('button[data-variant-id]');
      if (!button || button.dataset.busy === '1') return;

      const variantId = Number(button.getAttribute('data-variant-id'));
      if (!variantId) return;

      event.preventDefault();
      button.dataset.busy = '1';
      button.setAttribute('aria-busy', 'true');

      fetch(this._root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('cart ' + response.status);
          return response.json();
        })
        .then((added) => {
          // Kremi (10-16, davranış ölçümü): temanın variant:add olayı bu yolda yok → toplayıcıya ayrı olay.
          try { document.dispatchEvent(new CustomEvent('kremi:cart:added', { detail: { items: (added && added.items) || [] } })); } catch (_) {}
          window.location = this._root + 'checkout';
        })
        .catch(() => {
          // Eklenemedi (stok bitti, ağ koptu): butonu geri aç, ödemeye GÖNDERME.
          button.dataset.busy = '0';
          button.removeAttribute('aria-busy');
        });
    };

    this.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    if (this._onClick) this.removeEventListener('click', this._onClick);
  }
}

if (!customElements.get('kremi-buy-now')) {
  customElements.define('kremi-buy-now', KremiBuyNow);
}

/*
 * <kremi-ugc-deck> — aynı videoya bağlı 1-3 ürün kartının döngüsü.
 *
 * Kartlar sunucuda basılır (ilki görünür, diğerleri .is-hidden); bu element
 * yalnız SIRAYI çevirir: 4 sn'de bir sonraki kart, ya da kartı SAĞA/SOLA
 * kaydırınca (nokta gösterge BİLİNÇLİ YOK — kullanıcı kararı 09-15: dönüşün
 * kendisi yeterli sinyal). Tek kartlı deck'te hiçbir şey yapmaz. Dosya
 * yüklenmezse ilk kart görünür kalır — satış yolu kapanmaz, yalnız 2./3.
 * ürün erişilemez olur.
 *
 * DURAKLATMA ŞART, süs değil: imleç/odak karttayken döngü sürseydi tam
 * "Sepete ekle"ye basarken ürün altından değişir, YANLIŞ ürün eklenirdi.
 * prefers-reduced-motion'da otomatik dönüş hiç başlamaz; kaydırma elle çalışır.
 *
 * GÖRÜNÜRLÜK DIŞI DURAKLATMA (F8, 10-01 gündüz): sayfada çok sayıda deck varsa
 * (ör. UGC hikayeleri sayfası) ekran dışındaki kartlar da 4 sn'de bir setInterval
 * ateşliyordu — görünmez ama yine de her tick'te DOM sınıf değişimi/reflow. IntersectionObserver
 * ile "ekranda mı" ve document.visibilityState ile "sekme görünür mü" durumları hover/odak
 * duraklatmasıyla AYNI _pause/_resume yoluna bağlandı: ekran dışına çıkan/sekme gizlenen
 * deck durur, geri gelince hover-resume ile BİREBİR aynı şekilde (çizgi baştan, zamanlayıcı
 * baştan) devam eder — görünür haldeki davranış değişmez, yalnız görünmezken çalışmaz.
 *
 * KAYDIRMA: dış şerit deck üzerinde sürüklemeyi hiç başlatmıyor
 * (swiper-no-swiping) — bu alan bizim. CSS'te touch-action: pan-y dikey sayfa
 * kaydırmasını tarayıcıda bırakır. Eşik: yatay ≥40px VE yatayın dikeyden
 * belirgin büyük olması — buton tıklaması (dx≈0) ve dikey kaydırma karışmaz.
 * Fare sürüklemesi click'i BASTIRMAZ: kaydırma buton üzerinde biterse tarayıcı
 * yine click üretir ve ürün yanlışlıkla sepete giderdi — kaydırma algılanınca
 * hemen ardından gelen click yakalama fazında bir kez yutulur.
 */
class KremiUgcDeck extends HTMLElement {
  static ROTATE_MS = 4000;

  connectedCallback() {
    this._items = Array.from(this.querySelectorAll('.kremi-ugc-deck__item'));
    this._bars = Array.from(this.querySelectorAll('.kremi-ugc-deck__bar'));
    if (this._items.length < 2) return;

    // Gosterge cizgisinin dolma suresi = donus suresi; CSS bunu bu degiskenden
    // okur (tek kaynak burasi, CSS'teki 4s yalniz JS'siz yedek).
    this.style.setProperty('--kremi-ugc-rotate', KremiUgcDeck.ROTATE_MS + 'ms');

    // Swiper loop modu slaytlari DOM'da tasir → element yeniden baglanir;
    // sayac o anki GORUNUR karttan devam etmeli.
    const visible = this._items.findIndex((item) => !item.classList.contains('is-hidden'));
    this._index = visible < 0 ? 0 : visible;
    this._reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Calisip calismamasi gereken durum uc bagimsiz bayraktan hesaplanir: ekranda mi
    // (IntersectionObserver), sekme gorunur mu (visibilitychange), imlec/odak duraklatti mi
    // (pointerenter/focusin). Ucu de true olmadan zamanlayici calismaz.
    this._onScreen = false;
    this._pageVisible = !document.hidden;
    this._userPaused = false;
    this._running = false;

    this._applyRunState = () => {
      const shouldRun = this._onScreen && this._pageVisible && !this._userPaused;
      if (shouldRun === this._running) return;
      this._running = shouldRun;
      if (shouldRun) {
        this.classList.remove('is-paused');
        // Cizgi duraklama noktasindan degil bastan dolar — zamanlayici da
        // bastan basliyor; ikisi ayni hizada kalir.
        this._syncBars();
        this._restart();
      } else {
        this._stop();
        this.classList.add('is-paused');
      }
    };

    this._pause = () => {
      this._userPaused = true;
      this._applyRunState();
    };
    this._resume = () => {
      this._userPaused = false;
      this._applyRunState();
    };

    this._onVisibilityChange = () => {
      this._pageVisible = !document.hidden;
      this._applyRunState();
    };
    document.addEventListener('visibilitychange', this._onVisibilityChange);

    this._intersectionObserver = new IntersectionObserver((entries) => {
      this._onScreen = entries[entries.length - 1].isIntersecting;
      this._applyRunState();
    });
    this._intersectionObserver.observe(this);

    this._onPointerDown = (event) => {
      if (event.isPrimary === false) return;
      this._drag = { x: event.clientX, y: event.clientY };
    };
    this._onPointerCancel = () => {
      this._drag = null;
    };
    this._onPointerUp = (event) => {
      if (!this._drag) return;
      const dx = event.clientX - this._drag.x;
      const dy = event.clientY - this._drag.y;
      this._drag = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      this._suppressClick = true;
      setTimeout(() => {
        this._suppressClick = false;
      }, 400);
      const count = this._items.length;
      this._show(dx < 0 ? (this._index + 1) % count : (this._index - 1 + count) % count);
      this._restart();
    };
    this._onClickCapture = (event) => {
      if (!this._suppressClick) return;
      this._suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    };

    // Cizgi tiklamasi (masaustu; mobilde pointer-events kapali, klavye her yerde).
    this._onBarClick = (event) => {
      const bar = event.target.closest && event.target.closest('.kremi-ugc-deck__bar');
      if (!bar) return;
      const index = this._bars.indexOf(bar);
      if (index < 0) return;
      this._show(index);
      this._restart();
    };
    this.addEventListener('click', this._onBarClick);

    this.addEventListener('pointerdown', this._onPointerDown);
    this.addEventListener('pointerup', this._onPointerUp);
    this.addEventListener('pointercancel', this._onPointerCancel);
    this.addEventListener('click', this._onClickCapture, true);
    this.addEventListener('pointerenter', this._pause);
    this.addEventListener('pointerleave', this._resume);
    this.addEventListener('focusin', this._pause);
    this.addEventListener('focusout', this._resume);

    // Yeniden baglanmada (Swiper DOM tasimasi) cizgiler mevcut karta hizalanir; zamanlayici
    // IntersectionObserver'in ilk callback'i ekranda oldugunu bildirince _applyRunState
    // uzerinden baslar (asagida kurulan).
    this._syncBars();
  }

  disconnectedCallback() {
    this._stop();
    if (this._intersectionObserver) {
      this._intersectionObserver.disconnect();
      this._intersectionObserver = null;
    }
    if (this._onVisibilityChange) {
      document.removeEventListener('visibilitychange', this._onVisibilityChange);
    }
    if (!this._onPointerDown) return;
    this.removeEventListener('click', this._onBarClick);
    this.removeEventListener('pointerdown', this._onPointerDown);
    this.removeEventListener('pointerup', this._onPointerUp);
    this.removeEventListener('pointercancel', this._onPointerCancel);
    this.removeEventListener('click', this._onClickCapture, true);
    this.removeEventListener('pointerenter', this._pause);
    this.removeEventListener('pointerleave', this._resume);
    this.removeEventListener('focusin', this._pause);
    this.removeEventListener('focusout', this._resume);
  }

  _show(index) {
    this._index = index;
    this._items.forEach((item, i) => item.classList.toggle('is-hidden', i !== index));
    this._syncBars();
  }

  _syncBars() {
    if (!this._bars.length) return;
    this._bars.forEach((bar, i) => {
      bar.classList.toggle('is-done', i < this._index);
      bar.classList.remove('is-active');
      bar.setAttribute('aria-current', i === this._index ? 'true' : 'false');
    });
    const active = this._bars[this._index];
    if (!active) return;
    // Sinif ayni karede geri takilirsa animasyon SIFIRLANMAZ; reflow araya girer.
    void active.offsetWidth;
    active.classList.add('is-active');
  }

  _restart() {
    this._stop();
    if (this._reduced) return;
    this._timer = setInterval(() => {
      // Arka plan sekmesinde donme: kullanici donunce kart "ziplamis" olmasin.
      if (document.hidden) return;
      this._show((this._index + 1) % this._items.length);
    }, 4000);
  }

  _stop() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }
}

if (!customElements.get('kremi-ugc-deck')) {
  customElements.define('kremi-ugc-deck', KremiUgcDeck);
}
